export default "__VITE_ASSET__Dq0ixo6o__"